/**
 * interaction/facades/batch.facade.instance.js
 *
 * Production wiring — creates the batch facade with real dependencies.
 */

import { createBatchFacade } from './batch.facade.js';
import {
  createBatch,
  checkSif,
  getBatchJob,
  getBatchJobs,
  previewBatchKeywordStrategy,
  refreshSifLoginSession,
  startSifLoginSession,
  getAsinSnapshotJob,
} from '../../api/listing-api.js';
import { request } from '../transport/http-client.js';

export const batchFacade = createBatchFacade({
  createBatch,
  checkSif,
  getBatchJob,
  getBatchJobs,
  startSifLoginSession,
  refreshSifLoginSession,
  getBatchJobKeywords: (jobId) => request(`/api/batch-jobs/${jobId}/keywords`),
  previewBatchKeywordStrategy,
  getAsinSnapshotJob,
});
